import {
	AOFL_PRODUCT_NAMES,
	AOFL_PRODUCT_UUIDS,
	LINK_FROM_APP_PLATFORMS
} from '$lib/utils/constants';
import { has2_0Account } from '$lib/utils/aofl-accounts';
import { app } from '$lib/stores/app/store';
import { get } from 'svelte/store';
import { ProductExperienceService } from '$lib/services/product-experience';
import { user } from '$lib/stores/user/store.js';
import { WALMART_OFFER_HASHES } from '../../subscription/offer/[offer_hash]/__config/constants.js';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	inApp: {
		condition: async (config) => {
			return config?.global?.appProduct !== AOFL_PRODUCT_NAMES.ABCMOUSE_2_0 && config.meta.inApp;
		},
		resolve: async () => await import('../../inside-pw/_in-app/Page.svelte')
	},
	inApp2_0: {
		condition: async (config) => {
			return config?.global?.appProduct === AOFL_PRODUCT_NAMES.ABCMOUSE_2_0 && config.meta.inApp;
		},
		resolve: async () => await import('../_in_app_2-0/Page.svelte')
	},
	browserLinkFrom1_0App: {
		condition: async () => {
			// This handles iOS app users in 1.0 experience that link out to the sub page
			const isLinkFromIOSPlatform =
				get(app)?.global.linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS;
			const is1_0 = ProductExperienceService.AOFL_PRODUCT_UUID === AOFL_PRODUCT_UUIDS.ABCMOUSE;
			return isLinkFromIOSPlatform && is1_0;
		},
		resolve: async () => await import('../_browser/Page.svelte')
	},
	browser_walmart: {
		condition: async () => {
			const offerHash = get(user)?.userMetaData?.special_offer;
			return WALMART_OFFER_HASHES.includes(offerHash);
		},
		resolve: async () => await import('../_browser-walmart/Page.svelte')
	},
	browser1_0_User: {
		condition: async () => {
			return !has2_0Account();
		},
		resolve: async () => await import('../_browser/Page.svelte')
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte')
	}
};

export { pageConditions };
